import { ConnectedAllDevicesMap } from "fleet/controller/overview/connected-all-devices-map";
import { ConnectedStrategyTable } from "fleet/controller/overview/connected-strategy-stats";
import moment from "moment";
import PropTypes from "prop-types";
import React from "react";
import { Row, Col } from "react-bootstrap";
import { ConnectedDeviceStatsBox } from "ui/device-stats/connected-device-stats-box";
import { PlayerVersionStatsWidget } from "ui/widget/player-version-stats";
import { ConnectedWsDeviceStatusConnStatus } from "ui/ws-ds-conn-status/connected-ws-ds-conn-status";
import { Box } from "view/layout/box";
import { Page } from "view/layout/page";
import { SmallBox } from "view/layout/small-box";

class OverviewPage extends React.PureComponent {
  static get propTypes() {
    return {
      averageUptime: PropTypes.number,
      events: PropTypes.number,
      fetchAccountStats: PropTypes.func.isRequired,
    };
  }

  componentDidMount() {
    const yesterday = moment().subtract(1, "days").format("YYYY-MM-DD");
    this.props.fetchAccountStats({ yesterday });
  }

  _renderUptimeDescription() {
    return (
      <p>
        Average uptime (yesterday)
        <small>Production devices only</small>
      </p>
    );
  }

  _renderEventsDescription() {
    return (
      <p>
        Events (24h)
        <small>&nbsp;</small>
      </p>
    );
  }

  render() {
    const { averageUptime, events } = this.props;

    const percent = averageUptime ? `${averageUptime.toFixed(2)}%` : "0.00%";
    const eventCount = events ? events.toString() : "--";

    const uptimeDescription = this._renderUptimeDescription();
    const eventsDescription = this._renderEventsDescription();

    return (
      <Page title="Overview">
        <Row>
          <Col xs={12}>
            <ConnectedWsDeviceStatusConnStatus />
          </Col>
        </Row>
        <Row>
          <Col xs={3}>
            <ConnectedDeviceStatsBox isOnlinePanel={true} />
          </Col>
          <Col xs={3}>
            <ConnectedDeviceStatsBox isOnlinePanel={false} />
          </Col>
          <Col xs={3}>
            <SmallBox
              boxTitle={percent}
              desc={uptimeDescription}
              color="aqua"
              icon="bar-chart"
            />
          </Col>
          <Col xs={3}>
            <SmallBox
              boxTitle={eventCount}
              desc={eventsDescription}
              color="yellow"
              icon="bullhorn"
            />
          </Col>
        </Row>
        <Row>
          <Col xs={12}>
            <Box title="Device Locations">
              <ConnectedAllDevicesMap />
            </Box>
          </Col>
        </Row>
        <Row>
          <Col xs={6}>
            <PlayerVersionStatsWidget />
          </Col>
          <Col xs={6}>
            <ConnectedStrategyTable />
          </Col>
        </Row>
      </Page>
    );
  }
}

export { OverviewPage };
